import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import SvgIcon from '@material-ui/core/SvgIcon'

const styles = theme => ({
  size_12: {
    width: 12,
    height: 12
  },
  size_16: {
    width: 16,
    height: 16
  },
  size_32: {
    width: 32,
    height: 32
  }
})

export const ArrowRight = withStyles(styles)(
  ({ size, classes, ...otherProps }) => {
    return (
      <SvgIcon
        viewBox={`0 0 ${size} ${size}`}
        classes={{ root: classes[`size_${size}`] }}
        {...otherProps}
      >
        {size === 12 && (
          <polygon
            id="icons-arrow-right-12px"
            fill="currentColor"
            points="10 5.625 4 0 4 2.59615385 7.23076923 5.625 4 8.65384615 4 11.25"
          />
        )}
        {size === 16 && (
          <polygon
            id="icons-arrow-right-16px"
            fill="currentColor"
            fillRule="nonzero"
            points="12 7.5 4 0 4 3.46153846 8.30769231 7.5 4 11.5384615 4 15"
          />
        )}
      </SvgIcon>
    )
  }
)
ArrowRight.propTypes = {
  size: PropTypes.oneOf([12, 16]).isRequired
}

export const ArrowLeft = withStyles(styles)(
  ({ size, classes, ...otherProps }) => {
    return (
      <SvgIcon
        viewBox={`0 0 ${size} ${size}`}
        classes={{ root: classes[`size_${size}`] }}
        {...otherProps}
      >
        {size === 12 && (
          <polygon
            id="icons-arrow-left-16px"
            fill="currentColor"
            transform="translate(6.000000, 5.625000) scale(-1, 1) translate(-6.000000, -5.625000) "
            points="9 5.625 3 0 3 2.59615385 6.23076923 5.625 3 8.65384615 3 11.25"
          />
        )}
        {size === 16 && (
          <polygon
            id="icons-arrow-left-16px"
            fill="currentColor"
            fillRule="nonzero"
            transform="translate(8.000000, 7.500000) scale(-1, 1) translate(-8.000000, -7.500000) "
            points="12 7.5 4 0 4 3.46153846 8.30769231 7.5 4 11.5384615 4 15"
          />
        )}
      </SvgIcon>
    )
  }
)
ArrowLeft.propTypes = {
  size: PropTypes.oneOf([12, 16]).isRequired
}

export const ContentAll = withStyles(styles)(
  ({ size = 32, classes, ...otherProps }) => (
    <SvgIcon
      viewBox={`0 0 ${size} ${size}`}
      classes={{ root: classes[`size_${size}`] }}
      {...otherProps}
    >
      <g
        id="icons-content-show-all"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g fill="currentColor">
          <g transform="translate(2.000000, 8.000000)">
            <rect x="0" y="0" width="12" height="4" />
            <rect x="15" y="0" width="12" height="4" />
            <rect x="0" y="6" width="12" height="4" />
            <rect x="15" y="6" width="12" height="4" />
            <rect x="0" y="12" width="12" height="4" />
            <rect x="15" y="12" width="12" height="4" />
          </g>
        </g>
      </g>
    </SvgIcon>
  )
)

export const ContentLinked = withStyles(styles)(
  ({ size = 32, classes, ...otherProps }) => (
    <SvgIcon
      viewBox={`0 0 ${size} ${size}`}
      classes={{ root: classes[`size_${size}`] }}
      {...otherProps}
    >
      <g
        id="icons-content-show-linked"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g fill="currentColor">
          <rect x="15" y="10" width="1" height="12" />
          <rect x="0" y="8" width="12" height="4" />
          <rect x="19" y="8" width="12" height="4" />
          <rect x="19" y="14" width="12" height="4" />
          <rect x="19" y="20" width="12" height="4" />
          <rect x="15" y="15.5" width="4" height="1" />
          <rect x="12" y="9.5" width="7" height="1" />
          <rect x="15" y="21.5" width="4" height="1" />
        </g>
      </g>
    </SvgIcon>
  )
)

export const CloseIcon = withStyles(styles)(
  ({ size = 16, classes, ...otherProps }) => (
    <SvgIcon
      viewBox={`0 0 ${size} ${size}`}
      classes={{ root: classes[`size_${size}`] }}
      {...otherProps}
    >
      <g stroke="currentColor" strokeWidth="2">
        <path d="M4,4 L11.7781746,11.7781746" id="Path-2" />
        <path
          d="M4,4 L11.7781746,11.7781746"
          id="Path-2-Copy"
          transform="translate(7.889087, 7.889087) scale(-1, 1) translate(-7.889087, -7.889087) "
        />
      </g>
    </SvgIcon>
  )
)



// WEBPACK FOOTER //
// ./src/components/Icons.js